import { AccountCard } from '../account/account_card.js';
import { services } from '../app/services.js';
import { session } from '../app/session.js';
import { AsyncDataPipeableArray } from '../base/pipeable/async_data_pipeable_array.js';

/**
 * Friends.
 */
class Friends extends AsyncDataPipeableArray {
  find({ userId, inviteeUserId, inviteeEmail }) {
    let friend = this.data.find(
      f => f.id == userId || f.id == inviteeUserId || f.email == inviteeEmail
    );
    if (friend) {
      return friend;
    }

    let name = 'Incognito';
    let avatar = '/images/customer-40.png';
    let email = inviteeEmail || 'incognito@wentcamping';
    return new AccountCard({ name, email, avatar });
  }

  get dataClassName() {
    return 'friends';
  }

  getLoadPromise() {
    return services.profile
      .getFriends()
      .then(friends => friends.map(friend => new AccountCard(friend)));
  }

  static Sort = (a, b) => (a < b ? -1 : a > b ? 1 : 0);
}

const friends = new Friends();
session.hookOnChange(user => {
  friends.clear();
  if (user) {
    friends.load();
  }
});

export { friends };
